window.blckbxGetOrCreateClientId = function() {

    var clientId;

    try {
      clientId = sessionStorage.getItem('clientId');
    } catch(e) { /* ignore */ }

    if (! clientId) {
      clientId = window.blckbxGenerateClientID();

      try {
        sessionStorage.setItem('clientId', clientId);
      } catch(e) { /* ignore */ }
    }

    return clientId;
}

window.blckbxGenerateClientID = function() {

    if (typeof Crypto.randomUUID === 'function') {
        return Crypto.randomUUID();
    } else if (typeof crypto.getRandomValues === 'function') {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
    } else {
        return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    }
}

window.contentGroup = function() {

    let contentGroup = document.head.querySelector('meta[name="content-group"]');

    if(contentGroup)
    {
        return contentGroup.content;

    }else {

        return null;
    }
}


window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Alpine from 'alpinejs'
import mask from '@alpinejs/mask'

import Comment from './comments.js';

import ReadMore from './components/ReadMore.js'
import LoadMoreComments from './components/LoadMoreComments.js'
import LoadMoreEntries from './components/LoadMoreEntries.js'
import Lightbox from './components/Lightbox.js'
import CopyLink from './components/CopyLink.js'
import RumblePlayer from './components/RumblePlayer.js'
import Hero from './components/Hero.js'
import Slider from './components/Slider.js'
import SliderPrograms from './components/SliderPrograms.js'
import SliderItems from './components/SliderItems.js'
import NewsLetter from './components/NewsLetter.js'
import Navigation from './components/Navigation.js'
import ScrollToTarget from './components/ScrollToTarget.js'
import Register from './components/Register.js'
import RegisterEmailOnly from './components/RegisterEmailOnly.js'
import SmartNavigation from './components/SmartNavigation.js'
import CookieBanner from './components/CookieBanner.js'
import LowerGridBackground from './components/LowerGridBackground.js'
import Votes from './components/Votes.js'
import SearchBar from './components/SearchBar.js'
import FormToken from './components/FormToken.js'
import MailingLists from './components/MailingLists.js'
import CustomDonationForm from './components/CustomDonationForm.js'
import Popover from "./components/Popover";
import RegisterFullAccount from "./components/RegisterFullAccount";
import DonateLoginOptionsModal from "./components/DonateLoginOptionsModal.js";

window.Alpine = Alpine;
window.Comment = Comment;

Alpine.data('ReadMore', ReadMore);
Alpine.data('LoadMoreComments', LoadMoreComments);
Alpine.data('LoadMoreEntries', LoadMoreEntries);
Alpine.data('Lightbox', Lightbox);
Alpine.data('CopyLink', CopyLink);
Alpine.data('RumblePlayer', RumblePlayer);
Alpine.data('Hero', Hero);
Alpine.data('Slider', Slider);
Alpine.data('SliderPrograms', SliderPrograms);
Alpine.data('SliderItems', SliderItems);
Alpine.data('NewsLetter', NewsLetter);
Alpine.data('MailingLists', MailingLists);
Alpine.data('Navigation', Navigation);
Alpine.data('ScrollToTarget', ScrollToTarget);
Alpine.data('Register', Register);
Alpine.data('RegisterEmailOnly', RegisterEmailOnly);
Alpine.data('SmartNavigation', SmartNavigation);
Alpine.data('CookieBanner', CookieBanner);
Alpine.data('LowerGridBackground', LowerGridBackground);
Alpine.data('Votes', Votes);
Alpine.data('SearchBar', SearchBar);
Alpine.data('FormToken', FormToken);
Alpine.data('CustomDonationForm', CustomDonationForm);
Alpine.data('Popover', Popover)
Alpine.data('DonateLoginOptionsModal', DonateLoginOptionsModal);
Alpine.data('RegisterFullAccount', RegisterFullAccount)

Alpine.plugin(mask);

Alpine.start();
